import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import * as d3 from "d3";

const Axes = (props) => {
  let height = props.height;

  const xAxisRef = useRef();
  const yAxisRef = useRef();

  useEffect(() => {
    let xAxis = props.isLandscape
      ? d3.axisBottom(props.x).ticks(5)
      : d3.axisTop(props.x).ticks(5);
    let yAxis = props.isLandscape
      ? d3.axisLeft(props.y).ticks(5)
      : d3.axisLeft(props.y).ticks(5);

    d3.select(xAxisRef.current).call(xAxis);
    d3.select(yAxisRef.current).call(yAxis);
  }, [props.isLandscape, props.x, props.y]);

  return (
    <g className="axes">
      <g
        ref={xAxisRef}
        transform={
          props.isLandscape ? `translate(0, ${height})` : `translate(0, 0)`
        }
      />
      <g ref={yAxisRef} />
    </g>
  );
};

Axes.propTypes = {
  height: PropTypes.number.isRequired,
  isLandscape: PropTypes.bool,
  margin: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number
  }),
  x: PropTypes.func,
  xRange: PropTypes.array,
  y: PropTypes.func,
  yRange: PropTypes.array,
  width: PropTypes.number.isRequired
};

Axes.defaultProps = {
  height: 400,
  margin: {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30
  },
  isLandscape: true,
  x: d3.scaleLinear().domain([0, 100]),
  xRange: [0, 100],
  y: d3.scaleLinear().domain([0, 100]),
  yRange: [100, 0],
  width: 600
};

export default Axes;
